import React, { Component } from "react";
import './FooterMenu.css';

export default class FooterMenu extends Component {
  render() {
    return (
      <div id="footer">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="copyrights">
                © {new Date().getUTCFullYear()} Merum. All rights reserved.
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}